import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {GlobalMessageService, InternalServerErrorHandler, RoutingService} from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class CustomInternalServerErrorHandler extends InternalServerErrorHandler {

  handleError(): void {
     this.routingService.go('internal-server');
  }

  constructor(
    protected globalMessageService: GlobalMessageService,
    @Inject(PLATFORM_ID) protected platformId?,
    protected routingService?: RoutingService,
  ) {
    super(globalMessageService);
  }
}
